module.exports = __webpack_public_path__ + "static/media/business.689d47bb.jpeg";